import PortalIdParser from 'PortalIdParser';
import { ACCOUNT_BUSINESS_UNIT_ID, ALL_BUSINESS_UNITS_VALUE } from 'FormsCommonComponents/constants/BusinessUnits';
const SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY = 'SELECTED_BUSINESS_UNIT';
export const getCurrentBusinessUnit = () => {
  const PORTAL_ID = PortalIdParser.get();
  let localStorageValue = '0';
  let parsedBU = {};
  try {
    localStorageValue = window.localStorage.getItem(SELECTED_BUSINESS_UNIT_LOCAL_STORAGE_KEY) || '{}';
  } catch (e) {
    localStorageValue = '{}';
  }
  try {
    parsedBU = localStorageValue ? JSON.parse(localStorageValue) : 0;
  } catch (e) {
    parsedBU = {};
  }
  try {
    if (typeof parsedBU === 'object' && PORTAL_ID !== undefined) {
      return parsedBU[PORTAL_ID] || 0;
    } else {
      const sanitisedBU = String(parsedBU).replace(/^"|"$/g, '');
      return sanitisedBU === ALL_BUSINESS_UNITS_VALUE ? sanitisedBU : parseInt(String(parsedBU), 10);
    }
  } catch (e) {
    return 0;
  }
};
export const getIsShowingAllBusinessUnits = () => getCurrentBusinessUnit() === ALL_BUSINESS_UNITS_VALUE;
export const parseBusinessUnitId = (value, extraOptions = {}) => {
  const integerValue = parseInt(value, 10);
  const options = Object.assign({
    defaultValue: undefined,
    defaultToAccount: false
  }, extraOptions);
  if (Number.isInteger(integerValue) || integerValue === 0) {
    return integerValue;
  } else if (options.defaultToAccount) {
    return ACCOUNT_BUSINESS_UNIT_ID;
  } else {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'undefined' is not assignable to ... Remove this comment to see the full error message
    return parseInt(options.defaultValue, 10) || undefined;
  }
};
export const isBusinessUnitId = value => {
  const integerValue = parseInt(value, 10);
  return Number.isInteger(integerValue) || value === ACCOUNT_BUSINESS_UNIT_ID;
};
export const getBusinessUnitIdForLegalConsent = ({
  businessUnitId,
  hasBusinessUnitsAccess,
  isUngatedForCampaignBusinessUnit
}) => {
  if (hasBusinessUnitsAccess && !isUngatedForCampaignBusinessUnit) {
    return ACCOUNT_BUSINESS_UNIT_ID;
  } else if (hasBusinessUnitsAccess && isUngatedForCampaignBusinessUnit && isBusinessUnitId(businessUnitId)) {
    return businessUnitId;
  } else {
    return null;
  }
};
export const getLegalConsentSubscriptionsFilter = ({
  businessUnitId,
  hasBusinessUnitsAccess,
  isUngatedForCampaignBusinessUnit
}) => {
  const byBusinessUnitId = i => i.businessUnitId === parseBusinessUnitId(businessUnitId);
  const byAll = () => true;
  if (hasBusinessUnitsAccess && isUngatedForCampaignBusinessUnit && isBusinessUnitId(businessUnitId)) {
    return byBusinessUnitId;
  } else {
    return byAll;
  }
};
export const getUnavailableEmailSubscriptionsIdsByFormBusinessUnit = ({
  formBusinessUnitId,
  emailSubscriptions,
  hasBusinessUnitsAccess,
  isUngatedForCampaignBusinessUnit
}) => {
  if (hasBusinessUnitsAccess && isUngatedForCampaignBusinessUnit) {
    return emailSubscriptions.reduce((ids, i) => /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    i.businessUnitId !== formBusinessUnitId ? [...ids, i.id] : ids, []);
  } else {
    return [];
  }
};